import React from 'react';
import './ExerciseSteps.css';

const SummaryStep = ({ step, onContinue }) => {
  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        <div className="step-text">
          {step.content}
        </div>
        
        <div className="tool-learned">
          <div className="tool-icon">🎯</div>
          <div className="tool-content">
            <h3>Herramienta aprendida:</h3>
            <p className="tool-name">{step.tool_learned}</p>
          </div>
        </div>
      </div>
      
      <div className="step-actions">
        <button 
          className="step-button primary"
          onClick={onContinue}
        >
          Finalizar
        </button>
      </div>
    </div>
  );
};

export default SummaryStep; 